// Fixed industry taxonomy — mirrors the seeded Industry table in the tenancy service
// (Boxphish.Models migration AddTenancyIndustry). Classifies a tenancy into a peer set
// for industry benchmarking. Keep ids in sync with that seed.
//
// Single source of truth for the tenancy create (AddTenancyModal) and edit
// (CompanyInformation) forms so the two never drift apart.
export const INDUSTRIES = [
    { id: 1, name: "Financial Services" },
    { id: 2, name: "Healthcare" },
    { id: 3, name: "Education" },
    { id: 4, name: "Public Sector" },
    { id: 5, name: "Manufacturing" },
    { id: 6, name: "Retail & Hospitality" },
    { id: 7, name: "Technology" },
    { id: 8, name: "Legal" },
    { id: 9, name: "Professional Services" },
    { id: 10, name: "Charity & Non-profit" },
    { id: 11, name: "Construction & Property" },
    { id: 12, name: "Transport & Logistics" },
    { id: 13, name: "Energy & Utilities" },
    { id: 14, name: "Media & Marketing" },
    { id: 15, name: "Other" },
];
